export default __webpack_public_path__ + "static/media/social_whatsapp.71c61521.svg";